import React from 'react';

import NavBarTopUI from './NavBarTop';

function NavBarTop() {
    return <NavBarTopUI
    />
}

export default NavBarTop;